import { LogoSvg } from 'assets/svg';
import Link from 'components/Link';
import { typographyColors } from 'theme/colors';

const display = 'inline-block';

const Logo: React.FC = () => {
  return (
    <Link to='/'>
      <LogoSvg style={{ display, fill: typographyColors.light }} />
    </Link>
  );
};

export default Logo;
